import PublicApp from '@/views/mobile/PublicApp/Public'
import Personal from '@/views/mobile/PublicApp/components/Personal'
import Recharg from '@/views/mobile/PublicApp/components/Recharg'
import Spend from '@/views/mobile/PublicApp/components/Spend'
import ShopAddress from '@/views/mobile/PublicApp/components/ShopAddress'
import Freebie from '@/views/mobile/PublicApp/components/Freebie'

// 定义路由路径数列表
export default [{
  path: '/public',
  name: '公共',
  redirect: '/public/confirm',
  component: PublicApp,
  children: [{
    path: 'recharg',
    name: '充值',
    component: Recharg
  },
  {
    path: 'spend',
    name: '支付',
    component: Spend
  },
  {
    path: 'personal',
    name: '个人信息',
    component: Personal
  },
  {
    path: 'freebie',
    name: '赠品详情',
    component: Freebie
  },
  {
    path: 'address',
    name: '门店及电话',
    component: ShopAddress
  }]
}]



// WEBPACK FOOTER //
// ./src/views/mobile/PublicApp/routers/index.js